import React from "react";
import GroupedDigitControl from "../GroupedDigitControl";

// Découpage du NIR affiché dans le champ (1 2 2 2 3 3 2), comme partout ailleurs.
export const DECOUPAGE_NIR = [1, 2, 2, 2, 3, 3, 2];

/**
 * Champ « numéro de sécurité sociale » des écrans hors connexion : même mise
 * en forme par groupes que le reste du portail (GroupedDigitControl), dans le
 * cadre `.saisie` de la charte. `onChange` reçoit les chiffres seuls.
 */
const SaisieNir = ({ id, label = "Numéro de sécurité sociale", value, onChange, erreur = null, aide = null, autoFocus = false, valeurInitiale }) => {
  const idErreur = `${id}-error`;
  return (
    <div className={"champ" + (erreur ? " erreur" : "")}>
      <label htmlFor={id}>{label}</label>
      <div className="saisie">
        <GroupedDigitControl
          id={id}
          name="nir"
          value={value}
          valeurInitiale={valeurInitiale}
          separation={DECOUPAGE_NIR}
          separator={"   "}
          change={onChange}
          autoFocus={autoFocus}
          baseClassName=""
          className="saisie-nir"
          inputProps={{
            autoComplete: "username",
            maxLength: 36,
            "aria-invalid": erreur ? "true" : undefined,
            "aria-describedby": erreur ? idErreur : undefined,
          }}
        />
      </div>
      {aide}
      {/* Zone d'erreur toujours présente (vide sans erreur) : les lecteurs d'écran
          annoncent le message dès qu'il y apparaît. */}
      <p className="aide-erreur" id={idErreur} role="alert">
        {erreur}
      </p>
    </div>
  );
};

export default SaisieNir;
